/* RepeatHourComponent.js */

"use strict";
const Renderer = require("./RepeatHourRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class RepeatHourComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
    static defaultValue() {
        const next = this.getNextOneHourTimeFromNow();
        return {
            type: "poll",
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            every: {
                hour: 1,
            },
            start: {
                year: next.getFullYear(),
                month: next.getMonth(),
                date: next.getDate(),
                hour: next.getHours(),
            },
            minute: 0,
        };
    }
}
module.exports = RepeatHourComponent;
